export var _guardInputValues = function _guardInputValues(predictions, id) {
  if (predictions.length === 0) {
    return null;
  }

  if (predictions.length === 1) {
    return predictions[0];
  }

  if (!id) {
    return predictions[0];
  }

  return undefined; // eslint-disable-line no-undefined
};
export var _getPreviousPrediction = function _getPreviousPrediction(guardInputValues) {
  return function (predictions, id) {
    var guardedResult = guardInputValues(predictions, id);

    if (typeof guardedResult !== 'undefined') {
      return guardedResult;
    } // find index using filter instead of find for IE compatibility


    var currentIndex;
    var index = 0;
    predictions.filter(function (prediction) {
      if (prediction.__id__ === id) {
        currentIndex = index;
      }

      index++;
    });

    if (isNaN(currentIndex)) {
      return predictions[0];
    }

    var previousIndex = currentIndex - 1 < 0 ? predictions.length - 1 : currentIndex - 1;
    return predictions[previousIndex];
  };
};
export var _getNextPrediction = function _getNextPrediction(guardInputValues) {
  return function (predictions, id) {
    var guardedResult = guardInputValues(predictions, id);

    if (typeof guardedResult !== 'undefined') {
      return guardedResult;
    } // find index using filter instead of find for IE compatibility


    var currentIndex;
    var index = 0;
    predictions.filter(function (prediction) {
      if (prediction.__id__ === id) {
        currentIndex = index;
      }

      index++;
    });

    if (isNaN(currentIndex)) {
      return predictions[0];
    }

    var nextIndex = currentIndex + 1 >= predictions.length ? 0 : currentIndex + 1;
    return predictions[nextIndex];
  };
};
export var getNextPrediction = _getNextPrediction(_guardInputValues);
export var getPreviousPrediction = _getPreviousPrediction(_guardInputValues);
//# sourceMappingURL=predictions.js.map